export default __webpack_public_path__ + "assets/audio/ssml/w-token.0981fc709c566d8cbbec646caf3910a5.mp3";